import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTOR_VOICES_QUERY_KEYS } from "Actors/Api/Queries/actorVoicesQueryKeys";
import { deleteActorsActorIDActorVoicesActorVoiceIDTrainingFiles } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

export function useDeleteAllActorVoiceTrainingFilesMutation(actorID: string) {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    (actorVoiceID: string) =>
      deleteActorsActorIDActorVoicesActorVoiceIDTrainingFiles(
        actorID,
        actorVoiceID,
      ),
    {
      translationPrefix: getResourcePath(
        Resources.ApiErrors.DeleteAllActorVoiceTrainingFiles,
      ),
    },
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, actorVoiceID) => {
      queryClient.invalidateQueries({
        queryKey: ACTOR_VOICES_QUERY_KEYS.detail(actorID, actorVoiceID),
      });
    },
  });
}
